/* BlueMission — кадрова анимация при скрол (тениска с петно + кърпички с пяна).
   11 PNG кадъра от CDN; индексът се сменя според позицията на елемента в екрана.
   Устойчив старт: работи и ако скриптът се зареди СЛЕД DOMContentLoaded (defer / bfcache / late load). */
(function () {
  var CDN = "https://cdn.shopify.com/s/files/1/0799/0142/6004/files/";
  var sheetImages = [];
  var tshirtImages = [];
  var sheetV = ["1734523135","1734523135","1734523134","1734523135","1734523135","1734523135","1734523135","1734523135","1734523135","1734523134","1734523135"];
  var tshirtV = ["1734078823","1734078823","1734078823","1734078824","1734078823","1734078823","1734078823","1734078823","1734078823","1734078823","1734078823"];
  for (var i = 1; i <= 11; i++) {
    sheetImages.push(CDN + "sheet-" + i + ".png?v=" + sheetV[i - 1]);
    tshirtImages.push(CDN + "tshirt-" + i + ".png?v=" + tshirtV[i - 1]);
  }

  function preload(frames) { frames.forEach(function (src) { var im = new Image(); im.src = src; }); }

  function setupScrollAnimation(containerId, imgId, frames) {
    var container = document.getElementById(containerId);
    var img = document.getElementById(imgId);
    if (!container || !img) return;
    preload(frames);
    var last = -1;
    function update() {
      var rect = container.getBoundingClientRect();
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      if (!windowHeight) return;
      var visible = rect.top < windowHeight && rect.bottom > 0;
      if (!visible) return;
      var progress = (windowHeight - rect.top) / (windowHeight + rect.height);
      var index = Math.min(frames.length - 1, Math.max(0, Math.floor(progress * frames.length)));
      if (index !== last) { last = index; img.src = frames[index]; }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() {
    setupScrollAnimation("sheet-section", "sheet-image", sheetImages);
    setupScrollAnimation("cup-section", "cup-image", tshirtImages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  // при връщане назад от bfcache
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
})();
